import { getPermissions as getPermissionsRepo } from "@/services/api/RolesPermissionsRepository";
import { usePermissionsStore } from "@/zustand/permissionsStore";

export function getPermissions() {
  getPermissionsRepo()
    .then((res: any = {}) => {
      if (res && "data" in res) {
        usePermissionsStore.getState().setPermissions(res.data);
      }
    })
    .catch((error) => {
      console.error("axios error", error);
      return error;
    });
}
